import { useEffect } from "react";
import { SITE_URL } from "@/lib/api";

/* Titre, description, canonique et alternate. Le JSON-LD n'est plus produit ici :
   le prérendu en est la seule source, une fois par entité et par page. */
export function Seo({ title, description, path = "/", noindex = false }) {
  useEffect(() => {
    document.title = title;
    const setMeta = (name, content) => {
      let el = document.head.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("description", description);
    let canon = document.head.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.setAttribute("rel", "canonical");
      document.head.appendChild(canon);
    }
    canon.setAttribute("href", `${SITE_URL}${path}`);
    let alt = document.head.querySelector('link[rel="alternate"][hreflang="fr-FR"]');
    if (!alt) {
      alt = document.createElement("link");
      alt.setAttribute("rel", "alternate");
      alt.setAttribute("hreflang", "fr-FR");
      document.head.appendChild(alt);
    }
    alt.setAttribute("href", `${SITE_URL}${path}`);
    /* Page tenue hors index : la balise est posée tant que la page est affichée, puis
       retirée pour ne pas contaminer la page suivante. */
    if (!noindex) return undefined;
    const robots = document.createElement("meta");
    robots.setAttribute("name", "robots");
    robots.setAttribute("content", "noindex");
    document.head.appendChild(robots);
    return () => robots.remove();
  }, [title, description, path, noindex]);
  return null;
}
